export default "__VITE_ASSET__f1455738__"